export class LottieTemplates {
    static animatedTimers = [
        {
            name: "Countdown",
            id: "Countdown_1",
            json: require("@/assets/animated-overlays/timer-1/animation.json"),
            image: require("@/assets/animated-overlays/timer-1/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "line-width",
                    name: "Progress width",
                    width: {
                        path: "layers[1].shapes[2].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[0].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[0].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Progress color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[1].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[2].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: true,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 450,
                    },
                },
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ef[0].ef[0].v.k[0].t",
                        },
                        op: {
                            path: "layers[0].ef[0].ef[0].v.k[1].t",
                        },
                    },
                    {
                        id: 2,
                        ip: {
                            path: "layers[1].shapes[1].s.k[0].t",
                        },
                        op: {
                            path: "layers[1].shapes[1].s.k[1].t",
                        },
                    },
                    {
                        id: 3,
                        ip: {
                            path: "layers[0].ip",
                        },
                        op: {
                            path: "layers[0].op",
                        },
                    },
                    {
                        id: 4,
                        ip: {
                            path: "layers[1].ip",
                        },
                        op: {
                            path: "layers[1].op",
                        },
                    },
                    {
                        id: 5,
                        ip: {
                            path: "layers[2].ip",
                        },
                        op: {
                            path: "layers[2].op",
                        },
                    },
                ],
            },
            timers: {
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ef[0].ef[0].v.k[0].s[0]",
                        },
                        op: {
                            path: "layers[0].ef[0].ef[0].v.k[1].s[0]",
                        },
                    },
                ],
            },
            systemMethod: "animation-timer",
            type: "animation-timer",
        },
        {
            name: "Counter",
            id: "Counter_1",
            json: require("@/assets/animated-overlays/timer-1-inv/animation.json"),
            image: require("@/assets/animated-overlays/timer-1-inv/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "line-width",
                    name: "Progress width",
                    width: {
                        path: "layers[1].shapes[2].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[0].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[0].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Progress color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[1].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[2].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: true,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 450,
                    },
                },
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ef[0].ef[0].v.k[0].t",
                        },
                        op: {
                            path: "layers[0].ef[0].ef[0].v.k[1].t",
                        },
                    },
                    {
                        id: 2,
                        ip: {
                            path: "layers[1].shapes[1].s.k[0].t",
                        },
                        op: {
                            path: "layers[1].shapes[1].s.k[1].t",
                        },
                    },
                    {
                        id: 3,
                        ip: {
                            path: "layers[0].ip",
                        },
                        op: {
                            path: "layers[0].op",
                        },
                    },
                    {
                        id: 4,
                        ip: {
                            path: "layers[1].ip",
                        },
                        op: {
                            path: "layers[1].op",
                        },
                    },
                    {
                        id: 5,
                        ip: {
                            path: "layers[2].ip",
                        },
                        op: {
                            path: "layers[2].op",
                        },
                    },
                ],
            },
            timers: {
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ef[0].ef[0].v.k[0].s[0]",
                        },
                        op: {
                            path: "layers[0].ef[0].ef[0].v.k[1].s[0]",
                        },
                    },
                ],
            },
            systemMethod: "animation-timer",
            type: "animation-timer",
        },
        {
            name: "Circle progress bar",
            id: "Circle-progress-bar_1",
            json: require("@/assets/animated-overlays/timer-2/animation.json"),
            image: require("@/assets/animated-overlays/timer-2/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "line-width",
                    name: "Progress width",
                    width: {
                        path: "layers[0].shapes[2].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Background width",
                    width: {
                        path: "layers[1].shapes[1].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Progress color",
                    color: {
                        path: "layers[0].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[1].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: true,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 450,
                    },
                },
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ip",
                        },
                        op: {
                            path: "layers[0].op",
                        },
                    },
                    {
                        id: 2,
                        ip: {
                            path: "layers[1].ip",
                        },
                        op: {
                            path: "layers[1].op",
                        },
                    },
                    {
                        id: 3,
                        ip: {
                            path: "layers[0].shapes[1].s.k[0].t",
                        },
                        op: {
                            path: "layers[0].shapes[1].s.k[1].t",
                        },
                    },
                ],
            },
            systemMethod: "animation-timer",
            type: "animation-timer",
        },
        {
            name: "Circle progress bar (invert)",
            id: "Circle-progress-bar-inv_1",
            json: require("@/assets/animated-overlays/timer-2-inv/animation.json"),
            image: require("@/assets/animated-overlays/timer-2-inv/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "line-width",
                    name: "Progress width",
                    width: {
                        path: "layers[0].shapes[2].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Background width",
                    width: {
                        path: "layers[1].shapes[1].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Progress color",
                    color: {
                        path: "layers[0].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[1].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: true,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 450,
                    },
                },
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ip",
                        },
                        op: {
                            path: "layers[0].op",
                        },
                    },
                    {
                        id: 2,
                        ip: {
                            path: "layers[1].ip",
                        },
                        op: {
                            path: "layers[1].op",
                        },
                    },
                    {
                        id: 3,
                        ip: {
                            path: "layers[0].shapes[1].s.k[0].t",
                        },
                        op: {
                            path: "layers[0].shapes[1].s.k[1].t",
                        },
                    },
                ],
            },
            systemMethod: "animation-timer",
            type: "animation-timer",
        },
        {
            name: "Progress bar",
            id: "Progress-bar_1",
            json: require("@/assets/animated-overlays/timer-3/animation.json"),
            image: require("@/assets/animated-overlays/timer-3/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "line-width",
                    name: "Progress width",
                    width: {
                        path: "layers[0].shapes[2].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Background width",
                    width: {
                        path: "layers[1].shapes[1].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Progress color",
                    color: {
                        path: "layers[0].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[1].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: true,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 450,
                    },
                },
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ip",
                        },
                        op: {
                            path: "layers[0].op",
                        },
                    },
                    {
                        id: 2,
                        ip: {
                            path: "layers[1].ip",
                        },
                        op: {
                            path: "layers[1].op",
                        },
                    },
                    {
                        id: 3,
                        ip: {
                            path: "layers[0].shapes[1].e.k[0].t",
                        },
                        op: {
                            path: "layers[0].shapes[1].e.k[1].t",
                        },
                    },
                ],
            },
            systemMethod: "animation-timer",
            type: "animation-timer",
        },
        {
            name: "Progress bar (invert)",
            id: "Progress-bar-inv_1",
            json: require("@/assets/animated-overlays/timer-3-inv/animation.json"),
            image: require("@/assets/animated-overlays/timer-3-inv/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "line-width",
                    name: "Progress width",
                    width: {
                        path: "layers[0].shapes[2].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Background width",
                    width: {
                        path: "layers[1].shapes[1].w.k",
                        defaultValue: 52,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Progress color",
                    color: {
                        path: "layers[0].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[1].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: true,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 450,
                    },
                },
                layers: [
                    {
                        id: 1,
                        ip: {
                            path: "layers[0].ip",
                        },
                        op: {
                            path: "layers[0].op",
                        },
                    },
                    {
                        id: 2,
                        ip: {
                            path: "layers[1].ip",
                        },
                        op: {
                            path: "layers[1].op",
                        },
                    },
                    {
                        id: 3,
                        ip: {
                            path: "layers[0].shapes[1].e.k[0].t",
                        },
                        op: {
                            path: "layers[0].shapes[1].e.k[1].t",
                        },
                    },
                ],
            },
            systemMethod: "animation-timer",
            type: "animation-timer",
        },
    ];

    static animatedButtons = [
        {
            name: "PLAY NOW",
            time: 5,
            id: "PLAY NOW_1",
            json: require("@/assets/animated-overlays/button-play-now/animation.json"),
            image: require("@/assets/animated-overlays/button-play-now/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "inscribe-text-in-width",
                    text: {
                        path: "layers[3].t.d.k[0].s.t",
                        isTitle: true,
                        coef: 2.55,
                        maxWidth: 1390,
                    },
                    size: {
                        defaultValue: 68,
                        path: "layers[3].t.d.k[0].s.s",
                        max: 150,
                        min: 0,
                    },
                    bottomPadding: {
                        defaultValue: 24.836,
                        path: "layers[3].ks.p.k[1]",
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 8,
                        min: 0,
                        max: 56,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 3,
                        min: 0,
                        max: 25,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[3].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[3].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[4].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[4].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 6,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[4].shapes[3].c.k",
                    },
                    opacity: {
                        path: "layers[4].shapes[3].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 151,
                    },
                },
            },
            systemMethod: "animation-button",
            type: "animation-button",
        },
        {
            name: "PLAY NOW",
            time: 5,
            id: "PLAY NOW_2",
            json: require("@/assets/animated-overlays/button-play-now(red)/animation.json"),
            image: require("@/assets/animated-overlays/button-play-now(red)/image.png"),
            fps: {
                defaultValue: 30,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "inscribe-text-in-width",
                    text: {
                        path: "layers[3].t.d.k[0].s.t",
                        isTitle: true,
                        coef: 2.55,
                        maxWidth: 1390,
                    },
                    size: {
                        defaultValue: 68,
                        path: "layers[3].t.d.k[0].s.s",
                        max: 150,
                        min: 0,
                    },
                    bottomPadding: {
                        defaultValue: 24.836,
                        path: "layers[3].ks.p.k[1]",
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 56,
                        min: 0,
                        max: 56,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 3,
                        min: 0,
                        max: 25,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[3].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[3].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[4].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[4].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 6,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[4].shapes[3].c.k",
                    },
                    opacity: {
                        path: "layers[4].shapes[3].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 151,
                    },
                },
            },
            systemMethod: "animation-age-rating",
            type: "animation-age-rating",
        },
    ];

    static animatedAgeRatings = [
        {
            name: "0+",
            time: 5,
            id: "Age-0_1",
            json: require("@/assets/animated-overlays/age0/animation.json"),
            image: require("@/assets/animated-overlays/age0/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "inscribe-text-in-width",
                    text: {
                        path: "layers[1].t.d.k[0].s.t",
                        isTitle: true,
                        coef: 2.55,
                        maxWidth: 350,
                    },
                    size: {
                        defaultValue: 68,
                        path: "layers[1].t.d.k[0].s.s",
                        max: 120,
                        min: 0,
                    },
                    bottomPadding: {
                        defaultValue: -24.172,
                        path: "layers[1].ks.a.k[1]",
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 26,
                        min: 0,
                        max: 320,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[2].shapes[1].w.k",
                        defaultValue: 9,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[1].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[1].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[2].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 6,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[2].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-age-rating",
            type: "animation-age-rating",
        },
        {
            name: "4+",
            time: 5,
            id: "Age-4_1",
            json: require("@/assets/animated-overlays/age4/animation.json"),
            image: require("@/assets/animated-overlays/age4/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "inscribe-text-in-width",
                    text: {
                        path: "layers[1].t.d.k[0].s.t",
                        isTitle: true,
                        coef: 2.55,
                        maxWidth: 350,
                    },
                    size: {
                        defaultValue: 68,
                        path: "layers[1].t.d.k[0].s.s",
                        max: 120,
                        min: 0,
                    },
                    bottomPadding: {
                        defaultValue: -24.172,
                        path: "layers[1].ks.a.k[1]",
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 26,
                        min: 0,
                        max: 320,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[2].shapes[1].w.k",
                        defaultValue: 0,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Text color",
                    opacity: {
                        path: "layers[1].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[2].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 6,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[2].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-age-rating",
            type: "animation-age-rating",
        },
        {
            name: "7+",
            time: 5,
            id: "Age-7_1",
            json: require("@/assets/animated-overlays/age7/animation.json"),
            image: require("@/assets/animated-overlays/age7/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "inscribe-text-in-width",
                    text: {
                        path: "layers[1].t.d.k[0].s.t",
                        isTitle: true,
                        coef: 2.55,
                        maxWidth: 350,
                    },
                    size: {
                        defaultValue: 68,
                        path: "layers[1].t.d.k[0].s.s",
                        max: 120,
                        min: 0,
                    },
                    bottomPadding: {
                        defaultValue: -24.172,
                        path: "layers[1].ks.a.k[1]",
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 320,
                        min: 0,
                        max: 320,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[2].shapes[1].w.k",
                        defaultValue: 0,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[1].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[1].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[2].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 6,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[2].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-age-rating",
            type: "animation-age-rating",
        },
        {
            name: "12+",
            time: 5,
            id: "Age-12_1",
            json: require("@/assets/animated-overlays/age12/animation.json"),
            image: require("@/assets/animated-overlays/age12/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "inscribe-text-in-width",
                    text: {
                        path: "layers[1].t.d.k[0].s.t",
                        isTitle: true,
                        coef: 2.55,
                        maxWidth: 350,
                    },
                    size: {
                        defaultValue: 68,
                        path: "layers[1].t.d.k[0].s.s",
                        max: 120,
                        min: 0,
                    },
                    bottomPadding: {
                        defaultValue: -24.172,
                        path: "layers[1].ks.a.k[1]",
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 80,
                        min: 0,
                        max: 320,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[2].shapes[1].w.k",
                        defaultValue: 9,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[1].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[1].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[2].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 6,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[2].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-age-rating",
            type: "animation-age-rating",
        },
        {
            name: "18+",
            time: 5,
            id: "Age-18_1",
            json: require("@/assets/animated-overlays/age18/animation.json"),
            image: require("@/assets/animated-overlays/age18/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "inscribe-text-in-width",
                    text: {
                        path: "layers[1].t.d.k[0].s.t",
                        isTitle: true,
                        coef: 2.55,
                        maxWidth: 350,
                    },
                    size: {
                        defaultValue: 68,
                        path: "layers[1].t.d.k[0].s.s",
                        max: 120,
                        min: 0,
                    },
                    bottomPadding: {
                        defaultValue: -24.172,
                        path: "layers[1].ks.a.k[1]",
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 320,
                        min: 0,
                        max: 320,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[2].shapes[1].w.k",
                        defaultValue: 75,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Text color",
                    color: {
                        path: "layers[1].t.d.k[0].s.fc",
                    },
                    opacity: {
                        path: "layers[1].ks.o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[2].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[1].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 6,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[2].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[2].shapes[2].o.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-age-rating",
            type: "animation-age-rating",
        },
    ];


    static animatedShapes = [
        {
            name: "Ellipse-fill",
            id: "Ellipse-fill_1",
            json: require("@/assets/animated-overlays/shape-ellipse-fill/animation.json"),
            image: require("@/assets/animated-overlays/shape-ellipse-fill/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 800,
                        min: 0,
                        max: 800,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Ellipse-stroke",
            id: "Ellipse-stroke_1",
            json: require("@/assets/animated-overlays/shape-ellipse-stroke/animation.json"),
            image: require("@/assets/animated-overlays/shape-ellipse-stroke/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 800,
                        min: 0,
                        max: 800,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Polygon-stroke",
            id: "Polygon-stroke_1",
            json: require("@/assets/animated-overlays/shape-polygon-stroke/animation.json"),
            image: require("@/assets/animated-overlays/shape-polygon-stroke/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "number-points",
                    name: "Points",
                    points: {
                        path: "layers[0].ef[6].ef[0].v.k",
                        defaultValue: 6,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 0,
                        min: 0,
                        max: 170,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Rectangle-fill",
            id: "Rectangle-fill_1",
            json: require("@/assets/animated-overlays/shape-rectangle-fill/animation.json"),
            image: require("@/assets/animated-overlays/shape-rectangle-fill/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 0,
                        min: 0,
                        max: 800,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Rectangle-fill-round",
            id: "Rectangle-fill-round_1",
            json: require("@/assets/animated-overlays/shape-rectangle-fill-round/animation.json"),
            image: require("@/assets/animated-overlays/shape-rectangle-fill-round/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 320,
                        min: 0,
                        max: 800,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Rectangle-stroke",
            id: "Rectangle-stroke_1",
            json: require("@/assets/animated-overlays/shape-rectangle-stroke/animation.json"),
            image: require("@/assets/animated-overlays/shape-rectangle-stroke/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 0,
                        min: 0,
                        max: 800,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Rectangle-stroke-round",
            id: "Rectangle-stroke-round_1",
            json: require("@/assets/animated-overlays/shape-rectangle-stroke-round/animation.json"),
            image: require("@/assets/animated-overlays/shape-rectangle-stroke-round/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 320,
                        min: 0,
                        max: 800,
                    },
                },
                {
                    id: 2,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 3,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Star-fill",
            id: "Star-fill_1",
            json: require("@/assets/animated-overlays/shape-star-fill/animation.json"),
            image: require("@/assets/animated-overlays/shape-star-fill/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "number-points",
                    name: "Points",
                    points: {
                        path: "layers[0].ef[6].ef[0].v.k",
                        defaultValue: 5,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 0,
                        min: 0,
                        max: 170,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Star-stroke",
            id: "Star-stroke_1",
            json: require("@/assets/animated-overlays/shape-star-stroke/animation.json"),
            image: require("@/assets/animated-overlays/shape-star-stroke/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "number-points",
                    name: "Points",
                    points: {
                        path: "layers[0].ef[6].ef[0].v.k",
                        defaultValue: 5,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 0,
                        min: 0,
                        max: 170,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Triangle-fill",
            id: "Triangle-fill_1",
            json: require("@/assets/animated-overlays/shape-triangle-fill/animation.json"),
            image: require("@/assets/animated-overlays/shape-triangle-fill/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "number-points",
                    name: "Points",
                    points: {
                        path: "layers[0].ef[6].ef[0].v.k",
                        defaultValue: 3,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 0,
                        min: 0,
                        max: 170,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
        {
            name: "Triangle-stroke",
            id: "Triangle-stroke_1",
            json: require("@/assets/animated-overlays/shape-triangle-stroke/animation.json"),
            image: require("@/assets/animated-overlays/shape-triangle-stroke/image.png"),
            fps: {
                defaultValue: 1,
                path: "fr",
            },
            layers: [
                {
                    id: 1,
                    type: "number-points",
                    name: "Points",
                    points: {
                        path: "layers[0].ef[6].ef[0].v.k",
                        defaultValue: 3,
                        min: 0,
                        max: 100,
                    },
                },
                {
                    id: 2,
                    type: "border-radius",
                    name: "Border radius",
                    radius: {
                        path: "layers[0].ef[0].ef[0].v.k",
                        defaultValue: 0,
                        min: 0,
                        max: 170,
                    },
                },
                {
                    id: 3,
                    type: "line-width",
                    name: "Border width",
                    width: {
                        path: "layers[0].ef[1].ef[0].v.k",
                        defaultValue: 36,
                        min: 0,
                        max: 160,
                    },
                },
                {
                    id: 4,
                    type: "color-opacity",
                    name: "Border color",
                    color: {
                        path: "layers[1].shapes[1].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[4].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
                {
                    id: 5,
                    type: "color-opacity",
                    name: "Background color",
                    color: {
                        path: "layers[1].shapes[2].c.k",
                    },
                    opacity: {
                        path: "layers[0].ef[5].ef[0].v.k",
                    },
                    isVisible: true,
                    tempValue: 0,
                },
            ],
            duration: {
                isControlled: false,
                main: {
                    ip: {
                        path: "ip",
                        defaultValue: 0,
                    },
                    op: {
                        path: "op",
                        defaultValue: 1,
                    },
                },
            },
            systemMethod: "animation-shape",
            type: "animation-shape",
        },
    ]
}